
export default {
  name: 'SimpleCard',
  props: {
    color: {
      type: String,
      default: 'secondary'
    }
  }
}
